import images from '../img/images.js'

const resumeData = {
    experience: [
        {
            expImg: images.Pborbit,
            expCount: "1",
            expDate: "April 2024 - July 2024",
            expTitle: "Pb Orbit",
            expDesc: "Pickleball Sports management software for reducing administrative operations by seamless community, event management, live matches, real-time scheduling and updates"
        },
        {
            expImg: images.Krivitech,
            expCount: "3",
            expDate: "Feb 2024",
            expTitle: "Krivitech",
            expDesc: "Entirely developed a client's website and delivered within 2 weeks"
        },
        {
            expImg: images.Freight,
            expCount: "2",
            expDate: "March 2024 - April 2024",
            expTitle: "Freight Orbit",
            expDesc: "Advanced Dashboard for Import Export Companies to maintain sales reports, consols, clients and vendors via interactive charts, tables etc."
        },
        {
            expImg: images.Milisync,
            expCount: "4",
            expDate: "October 2024 - Current",
            expTitle: "ZVroX",
            expDesc: "Advanced Leads, Payrolls, Employees, Clients, Vendors, Invoice Management system with templates, forms etc. for Individual or Business usage."
        },
    ]
};

export default resumeData;
